import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Mo",
  "Di",
  "Mi",
  "Do",
  "Fr",
  "Sa",
  "So"
];

export default function MUIMultiSelect(props) {

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    props.onChange(typeof value === 'string' ? value.split(',') : value,)
  
  };

  return (
    <div>
      <FormControl sx={{ m: 1, ml:0, width: 258 }}>
        <InputLabel id="areaShiftSelect">Wochentage</InputLabel>
        <Select
          labelId="areaShiftSelect"
          id="demo-multiple-checkbox"
          multiple
          value={props.value}
          onChange={handleChange}
          input={<OutlinedInput label="Wochentage" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
          error={props.value.length === 0}
        >
          {names.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={props?.value?.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
